export const MENUS = {
  admin: [
    
    {
      label: "Users",
      icon: "mdi-account-group",
      children: [
        {
          label: "Customer",
          route: "/users/customer",
        },
        {
          label: "Operator",
          route: "/users/operators",
        },
      ],
    },
    { label: "Bookings", route: "/bookings", icon: "mdi-ticket-outline" },
    {
      label: "Bus Management",
      icon: "mdi-bus",
      children: [
        { label: "Bus", route: "/bus-management/bus" },
        { label: "City", route: "/bus-management/city" },
        { label: "Report", route: "/bus-management/report" },
      ],
    },
    {
      label: "Marketing",
      icon: "mdi-tag-multiple",
      children: [
        {
          label: "Referrals",
          route: "/marketing/refferals",
        },
        { label: "FAQ", route: "/marketing/faqs" },
      ],
    },
  ],

  operator: [
        { label: "Home", route: "/", icon: "mdi-home" },

    {
      label: "Users",
      icon: "mdi-account-group",
      children: [
        {
          label: "Operator",
           route: "/users/operators",
        },
      ],
    },
    { label: "Bookings", route: "/bookings", icon: "mdi-ticket-outline" },
    {
      label: "Bus Management",
      icon: "mdi-bus",
      children: [
        { label: "Report", route: "/bus-management/report" },
      ],
    },
  ],

  superAdmin: [
    { label: "Home", route: "/", icon: "mdi-home" },
    {
      label: "Users",
      icon: "mdi-account-group",
      children: [
        { label: "Admin", route: "/users/admins" },
        {
          label: "Customer",
          route: "/users/customers",
        },
        {
          label: "Operator",
          route: "/users/operators",
        }
      ],
    },
    { label: "Bookings", route: "/bookings", icon: "mdi-ticket-outline" },
    { label: "POS", route: "/pos", icon: "mdi-cellphone-settings" },
    {
      label: "Bus Management",
      icon: "mdi-bus",
      children: [
        { label: "Bus", route: "/bus-management/bus" },
        { label: "City", route: "/bus-management/city" },
        { label: "Report", route: "/bus-management/report" },
      ],
    },

    {
      label: "Payments",
      icon: "mdi-cash-multiple",
      children: [
        {
          label: "Settlement",
          route: "/payments/settlement",
        },
        {
          label: "Transaction",
          route: "/payments/transaction",
        },
      ],
    },

    {
      label: "Marketing",
      icon: "mdi-tag-multiple",
      children: [
        {
          label: "Coupon & Offers",
          route: "/marketing/coupons",
        },
        {
          label: "Advertisement",
          route: "/marketing/advertisement",
        },
        {
          label: "Referrals",
          route: "/marketing/refferals",
        },
        { label: "FAQ", route: "/marketing/faqs" },
      ],
    },
    {
      label: "Activity Management",
      icon: "mdi-alarm-light-outline",
      children: [
        {
          label: "Manage App",
          route: "/management/manage-app",
        },
        {
          label: "Notifications",
          route: "/management/notifications",
        },
      ],
    },
  ],
};

export const USER_ROLES = {
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  OPERATOR: "operator",
};
